import styled from 'styled-components';
import { Colors, Fonts } from '../utils/colors';

export const TerminalButton = styled.button`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid ${Colors.destructGreen};
  background: transparent;
  color: ${Colors.destructGreen};
  font-family: ${Fonts.mono};
  font-size: 13px;
  letter-spacing: 0.04em;
  cursor: pointer;
  text-shadow: 0 0 8px ${Colors.terminalGlow};
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;

  &:hover:not(:disabled) {
    background: ${Colors.destructGreen};
    color: ${Colors.onAccent};
    text-shadow: none;
    box-shadow: 0 0 18px ${Colors.terminalGlow};
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
`;

export const TerminalGhostButton = styled(TerminalButton)`
  border-color: ${Colors.terminalBorder};
  color: ${Colors.terminalText};
  text-shadow: none;

  &:hover:not(:disabled) {
    background: ${Colors.accentSoft};
    color: ${Colors.destructGreen};
    box-shadow: none;
  }
`;
